import React from 'react';
import {
  Agreement02Icon,
  CursorInWindowIcon,
  CheckListIcon,
  GoogleDocIcon,
  Mail02Icon,
  MapsLocation01Icon,
  MessageMultiple01Icon,
  RefreshIcon,
  SmartPhone01Icon,
  TaskDaily01Icon,
} from 'hugeicons-react';

const CHANNEL_ICON_SIZE = 16;

export const CHANNEL_META: Record<string, { label: string; icon: JSX.Element }> = {
  PHONE: { label: 'Telefon', icon: <SmartPhone01Icon size={CHANNEL_ICON_SIZE} /> },
  IN_PERSON: { label: 'Yüz yüze', icon: <MapsLocation01Icon size={CHANNEL_ICON_SIZE} /> },
  OFFLINE: { label: 'Yüz yüze', icon: <MapsLocation01Icon size={CHANNEL_ICON_SIZE} /> },
  LOCATION: { label: 'Yüz yüze', icon: <MapsLocation01Icon size={CHANNEL_ICON_SIZE} /> },
  ONLINE: { label: 'Online', icon: <CursorInWindowIcon size={CHANNEL_ICON_SIZE} /> },
  MEET: { label: 'Online', icon: <CursorInWindowIcon size={CHANNEL_ICON_SIZE} /> },
  EMAIL: { label: 'E-posta', icon: <Mail02Icon size={CHANNEL_ICON_SIZE} /> },
  MESSAGE: { label: 'Mesaj', icon: <MessageMultiple01Icon size={CHANNEL_ICON_SIZE} /> },
  SOFTWARE_PORTAL_FORM: { label: 'Yazılım / Portal / Form', icon: <TaskDaily01Icon size={CHANNEL_ICON_SIZE} /> },
  SYSTEM: { label: 'Yazılım / Portal / Form', icon: <TaskDaily01Icon size={CHANNEL_ICON_SIZE} /> },
  DOCUMENT_RECORD: { label: 'Doküman / Kayıt', icon: <GoogleDocIcon size={CHANNEL_ICON_SIZE} /> },
  DOCUMENT: { label: 'Doküman / Kayıt', icon: <GoogleDocIcon size={CHANNEL_ICON_SIZE} /> },
  OFFICIAL_LETTER: { label: 'Resmi Yazı / Tebligat', icon: <Agreement02Icon size={CHANNEL_ICON_SIZE} /> },
  OTHER: { label: 'Diğer', icon: <CheckListIcon size={CHANNEL_ICON_SIZE} /> },
  CHANGED: { label: 'Değişiklik', icon: <RefreshIcon size={CHANNEL_ICON_SIZE} /> },
  NOTE: { label: 'Not', icon: <MessageMultiple01Icon size={CHANNEL_ICON_SIZE} /> },
};
